export enum ClientSortingModeEnum {
  INTERNAL_NICKNAME_ALPHABETICAL_ASC = 'INTERNAL_NICKNAME_ALPHABETICAL_ASC',
  INTERNAL_NICKNAME_ALPHABETICAL_DESC = 'INTERNAL_NICKNAME_ALPHABETICAL_DESC',
  BILLING_ADDRESS_NAME_ALPHABETICAL_ASC = 'BILLING_ADDRESS_NAME_ALPHABETICAL_ASC',
  BILLING_ADDRESS_NAME_ALPHABETICAL_DESC = 'BILLING_ADDRESS_NAME_ALPHABETICAL_DESC',
  CREATE_DATE_ASC = 'CREATE_DATE_ASC',
  CREATE_DATE_DESC = 'CREATE_DATE_DESC',
  ADDRESS_NAME_AND_CLIENT_ID_ALPHABETICAL_DEFAULT = 'ADDRESS_NAME_AND_CLIENT_ID_ALPHABETICAL_DEFAULT'
}
